import { Badge, VerticalContainer } from '@/components';
import { Utils } from '@/shared/Utils';
import { ICouponDto, ICouponRedemptionDto } from '@/shared/interfaces';

import { R, format } from '@/caregiverSpace/resources/Texts.resx';

type CouponViewProps = {
    coupon: ICouponDto;
    couponRedemption: ICouponRedemptionDto;
};

export const CouponView = ({ coupon, couponRedemption }: CouponViewProps) => {
    return (
        <VerticalContainer spacing="sm">
            <div className="font-bold">{coupon.Name}</div>
            {coupon.GeneralConsultationsAllowed &&
                couponRedemption?.NumberOfActivations != null && (
                    <Badge className="font-normal">
                        {format(
                            R.ConsultationsUsed,
                            couponRedemption.NumberOfActivations.toString(),
                            coupon.GeneralConsultationsAllowed.toString(),
                        )}
                    </Badge>
                )}
            {couponRedemption?.ExpiresOn && (
                <div className="font-normal text-(--color-text-muted)">
                    {format(
                        R.ValidUntil,
                        Utils.formatShortDate(
                            new Date(couponRedemption.ExpiresOn),
                        ),
                    )}
                </div>
            )}
        </VerticalContainer>
    );
};
